import React from 'react';
import isNil from 'lodash/isNil';
import {
  notEmptyString,
} from '@populateui/utils';
import {
  EligibilityOverviewDependent,
} from 'dtos/eligibilityOverviewDependent';
import Section from 'views/EMR/components/Eligibility/Overview/Section';
import Address from 'views/EMR/components/Eligibility/Overview/Address';

type Props = {
  dependents: EligibilityOverviewDependent[];
};

function toDisplayValue(value?: string | null) {
  return notEmptyString(value) ? value : '–';
}

export default function Dependents({ dependents }: Props) {
  const hasDependents = !isNil(dependents) && dependents.length > 0;

  return hasDependents ? (
    <Section title="Dependents">
      <div className="grid grid-cols-6 gap-x-6 text-xs font-semibold text-gray-500 pb-2 border-b border-gray-200">
        <span>First name</span>
        <span>Middle name</span>
        <span>Last name</span>
        <span>Date of birth</span>
        <span>Gender</span>
        <span>Group number</span>
      </div>
      <div className="flex flex-col divide-y divide-gray-100">
        {dependents.map((dependent) => (
          <div
            key={`${dependent.firstName}-${dependent.lastName}-${dependent.dateOfBirth}`}
            className="py-3"
          >
            <div className="grid grid-cols-6 gap-x-6 text-xs font-semibold text-gray-700">
              <span>{toDisplayValue(dependent.firstName)}</span>
              <span>{toDisplayValue(dependent.middleName)}</span>
              <span>{toDisplayValue(dependent.lastName)}</span>
              <span>{toDisplayValue(dependent.dateOfBirth)}</span>
              <span>{toDisplayValue(dependent.gender)}</span>
              <span>{toDisplayValue(dependent.groupNumber)}</span>
            </div>
            <Address address={dependent.address} className="mt-3" title="Address" />
          </div>
        ))}
      </div>
    </Section>
  ) : null;
}
